// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./bao-dialog";
import ShiftScheduleSwapEmployeesViewModel from "./../view-models/shift-schedule-swap-employees";
class ShiftScheduleSwapEmployeesDialog {
    Def: JQueryDeferred<void>;
    BaoSearchBind: Bindings.baoSearcher;
    IsLoading: KnockoutObservable<boolean>;
    UrlDialog: KnockoutObservable<string> = ko.observable("ShiftScheduleSwapEmployees");
    DialogWidth = "600";
    PersonAId: string;
    PersonBId: string;
    ValidDate: string;
    PersonAName: string;
    PersonBName: string;
    private dialog: BaoDialog;
    constructor(isLoading: KnockoutObservable<boolean>, personAId?: string, personBId?: string, validDate?: string, personAName?: string, personBName?: string) {
        //BaoDialog()
        // open baodialog and load html and viewmodel via controller ...
        // set ViewModel's properties: personAId, personBId & validDate
        this.IsLoading = isLoading;
        this.PersonAId = personAId;
        this.PersonBId = personBId;
        this.ValidDate = validDate;
        this.PersonAName = personAName;
        this.PersonBName = personBName;
    }
    /**
     * Show Dialog
     * @param
     * @returns JQueryPromise<boolean> when dialog is closed with ok/saved/success=true, else false
     */
    Dialog(id?: string): JQueryPromise<boolean> {
        this.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: id,
            personAId: this.PersonAId,
            personBId: this.PersonBId,
            validDate: this.ValidDate
        })).then((result: Factories.GenericListResponse.DialogResponse) => {
            this.dialog = new BaoDialog(Bao.Session.ApplicationName);
            let vm = new ShiftScheduleSwapEmployeesViewModel(this.PersonAId, this.PersonBId, this.ValidDate, this.PersonAName, this.PersonBName);
            vm.IsLoading = this.IsLoading;
            this.dialog.ViewModel(vm);
            let okButton = new BaoDialog.ButtonFactory(this.dialog, Bao.Session.GetMessage("msgOk"), () => {
                vm.CheckInput()
                    .then(() => { return vm.SwapShiftPlans(); })
                    .then(() => {
                    this.dialog.DialogResult(true);
                    this.dialog.Close();
                });
            });
            let cancelButton = new BaoDialog.ButtonFactory(this.dialog, Bao.Session.GetMessage("msgCancel"), () => {
                this.dialog.Close();
                this.dialog.DialogResult(false);
            });
            if (this.DialogWidth != null) {
                this.dialog.Width(this.DialogWidth + "px");
            }
            this.dialog.Buttons([okButton, cancelButton]);
            this.dialog.Template(result.Template);
            this.IsLoading(false);
            // will resolve when closed
            return this.dialog.Open(null);
            // if dialog is closed
        }).then(() => {
            return $.Deferred<boolean>().resolve(Boolean(this.dialog.DialogResult())).promise();
        });
    }
}
export default ShiftScheduleSwapEmployeesDialog;